import * as Yup from 'yup';

const required = 'validator.required';

export const CreateRoutineValuesSchema = Yup.object().shape({
  name: Yup.string().required(required),
  description: Yup.string().required(required),
  durationHours: Yup.number()
    .min(0, 'validator.error.notNegative')
    .required(required),
  durationMinutes: Yup.number()
    .min(0, 'validator.error.notNegative')
    .required(required),
  durationSeconds: Yup.number()
    .min(0, 'validator.error.notNegative')
    .required(required),
  departmentId: Yup.string().nullable()
});
